/* eslint-disable */
export const SCOPE = 'router';
